import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getDownloadReceiptData } from '../../services/history/history-service';
import { IVatReceipt } from '../../models/history';
import { StandardResponse } from '../../models/standard-response';

export const useDownloadVATReceipt = () => {
  const [isAPICalled, setIsAPICalled] = useState<boolean>(false);

  const [isUnauthorisedUser, setIsUnauthorisedUser] = useState<boolean>(false);
  const [isAllowedToDownload, setIsAllowedToDownload] = useState<boolean>(true);
  const [receipt, setReceipt] = useState<IVatReceipt | null>(null);

  const params = useParams();

  useEffect(() => {
    fetchReceiptData();
  }, []);

  const fetchReceiptData = async () => {
    const encryptedSessionId = params?.session_id;
    const encryptedSessionPrimaryId = params?.session_primary_id;

    if (encryptedSessionId !== null && encryptedSessionId !== undefined) {
      await getDownloadReceiptData({
        sessionId: encryptedSessionId,
        sessionPrimaryId: encryptedSessionPrimaryId ? encryptedSessionPrimaryId : null,
      })
        .then(async (res: StandardResponse<IVatReceipt>) => {
          const pdfDownloadLink = res.Data.invoice_url;
          if (pdfDownloadLink !== '') {
            window.open(pdfDownloadLink, '_self');
            setReceipt(res.Data);
            setTimeout(() => {
              window.close();
            }, 2000);
          }
        })
        .catch((m) => {
          if (m && m.response && m.response.status && m.response.status === 404) {
            setIsUnauthorisedUser(true);
          } else if (m?.response?.data && m.response.data.error_code === 'ReceiptNotAllowedWhenNegativeBalance') {
            setIsAllowedToDownload(false);
          }
        })
        .finally(() => {
          setIsAPICalled(true);
        });
    }
  };

  return {
    fetchReceiptData,
    isUnauthorisedUser,
    isAllowedToDownload,
    receipt,
    isAPICalled,
  };
};
